import React from "react";
import { useTranslation } from "react-i18next";

/** Small pill marking a row that belongs to the loaded sample dataset. */
const SampleBadge: React.FC = () => {
  const { t } = useTranslation();
  return (
    <span className="inline-flex items-center rounded-full bg-secondary-95 px-2 py-0.5 text-xs font-medium text-secondary-30 dark:bg-secondary-20 dark:text-secondary-80">
      {t("sampleData.badge", "Sample")}
    </span>
  );
};

export default SampleBadge;
